module.exports = "<div lr-tap=\"vm.events.onClick()\" ng-if=\"!hide\">\n    <i class=\"lr lr-share\"></i>\n</div>\n";